import { Field, Combobox, Option, Link } from '@fluentui/react-components';
import styled from 'styled-components';

export const GoalsQuartersContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 26px;
  padding-top: 11px;
  padding-bottom: 13px;
  background: ${({ theme }) => theme.goalsTableHeaderBackground};
  [class*='fui-Combobox'] {
    width: 70px;
  }
  @media (max-width: 768px) {
    width: calc(306px * 4);
  }
`;

export const QuarterField = styled(Field)`
  width: 50px;
`;

export const QuarterSelector = styled(Combobox)`
  border: 0;
  outline: none;
  min-width: unset;

  input {
    width: 50px;
    font-size: 14px;
    font-weight: 700;
  }

  &:focus-within::after,
  &:focus::after {
    outline: none;
    border: none;
    display: none;
  }

   p {
    margin-right: auto;
    color: #5b5fc7;
    cursor: pointer;
  }
`;

export const QuarterOption = styled(Option)<{isSelected: boolean}>`

${({ isSelected }) => isSelected && `
&:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #5B5FC7;
  border-radius: 100%;
  display: inline-block;
  margin-left: auto;
}
`}
`;

export const QuarterArrowContainer = styled.div`
  margin-left: 50px;
  display: flex;
  align-items: center;
  gap: 7px;
  position: relative;
  z-index: 10;
  svg {
    cursor: pointer;
  }
`;

export const StyledLink = styled(Link)`
  color: #5b5fc7;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  &:focus, &:hover, &:visited, &:link, &:active {
    text-decoration: none;
}
`
